<div class="slideshow-outer" [class.slideshow-outer--single]="isSingleSlide()">
  <div class="splide" #splide>
    <div class="splide__track">
      <div class="splide__list">@for (slide of slideShowItemList(); track slide.idItem; let slideIndex = $index) {
          <div class="splide__slide" [attr.data-slide-id]="slide.idItem">
        <ng-container *ngTemplateOutlet="slideWrapper; context: { slide: slide, slideIndex: slideIndex }"></ng-container>
          </div>
        }</div>
    </div>
  </div>
</div>

<ng-template #slideWrapper let-slide="slide" let-slideIndex="slideIndex">
  @if (slide.linkUrl) {
    @if (isLinkExternal(slide.linkUrl)) {
      <a class="slide-link" [href]="slide.linkUrl" target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="slideContent; context: { slide: slide, slideIndex: slideIndex }"></ng-container>
      </a>
    } @else {
      <a class="slide-link" [routerLink]="getInternalRouterLink(slide.linkUrl)" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="slideContent; context: { slide: slide, slideIndex: slideIndex }"></ng-container>
      </a>
    }
  } @else {
    <ng-container *ngTemplateOutlet="slideContent; context: { slide: slide, slideIndex: slideIndex }"></ng-container>
  }
</ng-template>

<ng-template #slideContent let-slide="slide" let-slideIndex="slideIndex">
  @if (getSlideYoutubeUrl(slide)) {
    <ng-container *ngTemplateOutlet="youtubeTpl; context: { slide: slide, slideIndex: slideIndex }"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="imageTpl; context: { slide: slide, slideIndex: slideIndex }"></ng-container>
  }
</ng-template>

<ng-template #youtubeTpl let-slide="slide" let-slideIndex="slideIndex">
  <div class="yt-wrapper" [class.yt-wrapper--vertical]="isShowingVerticalVideo(slide)">
    @if (!isYouTubeIframeLoaded(slide.idItem)) {
      <div class="yt-loading-placeholder" aria-hidden="true">
        <div class="yt-loading-placeholder__glow"></div>
        <div class="yt-loading-placeholder__content">
          <img
            class="yt-loading-placeholder__logo"
            src="/assets/img/memorabid-logo-white.svg"
            alt=""
          />
          <span class="yt-loading-placeholder__label">Loading video</span>
        </div>
      </div>
    }

    <iframe
      [attr.data-slide-id]="slide.idItem"
      class="yt-frame"
      [class.yt-frame--loaded]="isYouTubeIframeLoaded(slide.idItem)"
      [src]="getSlideYoutubeUrl(slide)"
      title="YouTube video player"
      allow="accelerometer; autoplay; encrypted-media; gyroscope"
      loading="eager"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
    <div class="yt-overlay" [style.cursor]="slide.linkUrl ? 'pointer' : 'default'"></div>
  </div>
</ng-template>

<ng-template #imageTpl let-slide="slide" let-slideIndex="slideIndex">
  <picture>
    <source [srcset]="(slide.mobileImageUrl ?? slide.imageUrl) + '?w=1200'" media="(max-width: 768px)">
    <source [srcset]="(slide.imageUrl ?? slide.mobileImageUrl) + '?w=1200'" media="(max-width: 800px)">
    <source [srcset]="(slide.imageUrl ?? slide.mobileImageUrl) + '?w=1200'" media="(max-width: 1200px)">
    <source [srcset]="(slide.imageUrl ?? slide.mobileImageUrl) + '?w=1600'" media="(max-width: 1600px)">
    <source [srcset]="(slide.imageUrl ?? slide.mobileImageUrl) + '?w=2000'" media="(max-width: 2000px)">
    <img [src]="(slide.imageUrl ?? slide.mobileImageUrl) + '?w=2000'" alt="Slide"
      [attr.loading]="slideLoadingMode()"
      [attr.fetchpriority]="slideFetchPriority()"
      decoding="async" />
  </picture>
</ng-template>
